import { gql } from '@apollo/client';

import {
  InitiateUnifiedSessionDocument,
  type InitiateUnifiedSessionMutation,
  type InitiateUnifiedSessionMutationVariables,
} from '../__generated__/documents';

/**
 * Starts a unified session without writing anything to the database — the
 * insight is materialised on the first answer and reuses `sessionId` as its
 * id, so `sessionId` is the `insightId` every later call takes.
 *
 * `@unmask` on `...UnifiedQuestion`: see `add-question-message.gql.ts` —
 * masking strips `id` here too, so `client.readFragment` cannot identify the
 * entity.
 */
if (false) {
  gql`
    mutation InitiateUnifiedSession($input: InitiateUnifiedSessionInput!) {
      initiateUnifiedSession(input: $input) {
        sessionId
        firstQuestion {
          ...UnifiedQuestion @unmask
        }
      }
    }
  `;
}

export const INITIATE_UNIFIED_SESSION = InitiateUnifiedSessionDocument;
export type {
  InitiateUnifiedSessionMutation,
  InitiateUnifiedSessionMutationVariables,
};
